'use strict'

import axios from 'axios'

export const http = axios

export default http
